import React from "react";
import { generatePath } from "react-router-dom";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import PersonIcon from "@material-ui/icons/Person";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import SettingsIcon from "@material-ui/icons/Settings";
import {
  BRAND_CATEGORIES,
  BRAND_CUSTOMERS,
  BRAND_DASHBOARD,
  BRAND_DISPENSARIES,
  BRAND_BATCHES,
  BRAND_ORDERS_WITH_TYPE,
  BRAND_PRODUCTS,
  BRAND_SETTINGS,
  BRAND_USERS,
  ROLES,
  BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID,
  HOME,
  BRAND_REWARDS,
  BRAND_REWARDS_LOG,
  DRIVER_ORDERS,
  BRAND_MESSAGES,
} from "./constants";
import products from "./assets/img/products.svg";
import areas from "./assets/img/areas.svg";
import orders from "./assets/img/orders.svg";
import batches from "./assets/img/batches.svg";
import rewards from "./assets/img/rewards.svg";
import rewardsAll from "./assets/img/rewards-all.svg";
import category from "./assets/img/category.svg";
import newOrders from "./assets/img/new-orders.svg";
import inProgressOrders from "./assets/img/in-progress-orders.svg";
import fulfilledOrders from "./assets/img/fulfilled-orders.svg";
import canceledOrders from "./assets/img/canceled-orders.svg";
import archivedOrders from "./assets/img/archived-orders.svg";
import rewardLog from "./assets/img/reward-log.svg";
import message from "./assets/img/message.svg";

export const routesBrandAdmin = (brandId) => [
  {
    name: "Dashboard",
    path: generatePath(BRAND_DASHBOARD, { brandId }),
    icon: <EqualizerIcon />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Products",
    path: generatePath(BRAND_PRODUCTS, { brandId }),
    icon: <img src={products} alt="products" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Categories",
    path: generatePath(BRAND_CATEGORIES, { brandId }),
    icon: <img src={category} alt="categories" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Orders",
    path: generatePath(BRAND_ORDERS_WITH_TYPE, {
      brandId,
      ordersType: "new",
    }),
    icon: <img src={orders} alt="orders" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
    children: [
      {
        name: "New orders",
        path: generatePath(BRAND_ORDERS_WITH_TYPE, {
          brandId,
          ordersType: "new",
        }),
        icon: <img src={newOrders} alt="new orders" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
      {
        name: "In progress",
        path: generatePath(BRAND_ORDERS_WITH_TYPE, {
          brandId,
          ordersType: "progress",
        }),
        icon: <img src={inProgressOrders} alt="in progress" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
      {
        name: "Fulfilled",
        path: generatePath(BRAND_ORDERS_WITH_TYPE, {
          brandId,
          ordersType: "fulfilled",
        }),
        icon: <img src={fulfilledOrders} alt="fulfilled" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
      {
        name: "Canceled",
        path: generatePath(BRAND_ORDERS_WITH_TYPE, {
          brandId,
          ordersType: "canceled",
        }),
        icon: <img src={canceledOrders} alt="canceled" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
      {
        name: "Archived",
        path: generatePath(BRAND_ORDERS_WITH_TYPE, {
          brandId,
          ordersType: "archived",
        }),
        icon: <img src={archivedOrders} alt="archived" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
    ],
  },
  {
    name: "Employees",
    path: generatePath(BRAND_USERS, { brandId }),
    icon: <PersonIcon />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Customers",
    path: generatePath(BRAND_CUSTOMERS, { brandId }),
    icon: <PeopleAltIcon />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Messages",
    path: generatePath(BRAND_MESSAGES, { brandId }),
    icon: <img src={message} alt="message" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Dispensaries",
    path: generatePath(BRAND_DISPENSARIES, { brandId }),
    icon: <img src={areas} alt="dispensaries" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "QR Batches",
    path: generatePath(BRAND_BATCHES, { brandId }),
    icon: <img src={batches} alt="batches" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
  {
    name: "Extra Rewards",
    path: generatePath(BRAND_REWARDS, { brandId }),
    icon: <img src={rewards} alt="rewards" />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
    children: [
      {
        name: "All Rewards",
        path: generatePath(BRAND_REWARDS, { brandId }),
        icon: <img src={rewardsAll} alt="rewards all" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
      {
        name: "Reward log",
        path: generatePath(BRAND_REWARDS_LOG, { brandId }),
        icon: <img src={rewardLog} alt="rewards log" />,
        access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
      },
    ],
  },
  {
    name: "Settings",
    path: generatePath(BRAND_SETTINGS, { brandId }),
    icon: <SettingsIcon />,
    access: [ROLES.admin, ROLES.superAdmin, ROLES.brandManager],
  },
];

export const routesBudtender = [
  {
    name: "Orders",
    path: generatePath(BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID, {
      ordersType: "new",
    }),
    icon: <img src={orders} alt="products" />,
    access: [ROLES.brandBudtender],
    selected: [HOME],
    children: [
      {
        name: "New orders",
        path: generatePath(BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID, {
          ordersType: "new",
        }),
        icon: <img src={newOrders} alt="new orders" />,
        access: [ROLES.brandBudtender],
        selected: [HOME],
      },
      {
        name: "In progress",
        path: generatePath(BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID, {
          ordersType: "progress",
        }),
        icon: <img src={inProgressOrders} alt="in progress" />,
        access: [ROLES.brandBudtender],
        selectedDriver: [HOME],
      },
      {
        name: "Fulfilled",
        path: generatePath(BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID, {
          ordersType: "fulfilled",
        }),
        icon: <img src={fulfilledOrders} alt="fulfilled" />,
        access: [ROLES.brandBudtender],
      },
      {
        name: "Canceled",
        path: generatePath(BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID, {
          ordersType: "canceled",
        }),
        icon: <img src={canceledOrders} alt="canceled" />,
        access: [ROLES.brandBudtender],
      },
      {
        name: "Archived",
        path: generatePath(BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID, {
          ordersType: "archived",
        }),
        icon: <img src={archivedOrders} alt="archived" />,
        access: [ROLES.brandBudtender],
      },
    ],
  },
];

export const routesDriver = [
  {
    name: "Orders",
    path: generatePath(DRIVER_ORDERS),
    icon: <img src={orders} alt="products" />,
    access: [ROLES.brandDriver],
    selected: [HOME],
  },
];
